'use strict';

import { initAllModules } from './functions.js';

import PhotolistModule from './PhotolistModule.js';
import SignaturePadModule from './SignaturePadModule.js';
import ScrollToFirstErrorModule from './ScrollToFirstErrorModule.js';
import SharePopupModule from './SharePopupModule.js';
import ScrollGradientModule from './ScrollGradientModule.js';
import SumElement from './elements/SumElement.js';


window.modules = window.modules || {}

Object.assign(window.modules, {
    PhotolistModule,
    SignaturePadModule,
    ScrollToFirstErrorModule,
    SharePopupModule,
    ScrollGradientModule,
});

window.addEventListener('load', function() {
    initAllModules();
});

customElements.define('sum-element', SumElement);
